var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 15,
    fill: "#D9D9D9",
    stroke: "#ADADAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8322 3.1263C11.0386 3.30976 11.0572 3.6258 10.8737 3.83219L7.16898 8.00001L10.8737 12.1678C11.0572 12.3742 11.0386 12.6903 10.8322 12.8737C10.6258 13.0572 10.3098 13.0386 10.1263 12.8322L6.1263 8.33219C5.9579 8.14274 5.9579 7.85727 6.1263 7.66782L10.1263 3.16782C10.3098 2.96143 10.6258 2.94284 10.8322 3.1263Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8322 3.1263C20.0386 3.30976 20.0572 3.6258 19.8737 3.83219L16.169 8.00001L19.8737 12.1678C20.0572 12.3742 20.0386 12.6903 19.8322 12.8737C19.6258 13.0572 19.3098 13.0386 19.1263 12.8322L15.1263 8.33219C14.9579 8.14274 14.9579 7.85727 15.1263 7.66782L19.1263 3.16782C19.3098 2.96143 19.6258 2.94284 19.8322 3.1263Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.c1fdfaaa62b3e28fd21980fb9e7e0149.svg";
export { ForwardRef as ReactComponent };